/**
 * Sends uncaught browser errors to Sentry, using the settings in the
 * `<meta name="sentry">` tag.
 */

import * as Sentry from "@sentry/browser";
import { isInjectedScriptError } from "./sentry_filters";

const meta = document.querySelector("meta[name='sentry']");

if (meta) {
  const { dsn, environment, release } = meta.dataset;

  Sentry.init({
    dsn,
    environment,
    release,
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpBodies: [],
      urlQueryParams: false,
    },
    beforeSend: (event) => (isInjectedScriptError(event) ? null : event),
  });
} else {
  console.warn(
    "Unable to find Sentry meta tag, browser errors won't be reported",
  );
}
